import React from "react";

import { Col, Divider, Form, Input, Row } from "antd";

const CooperateLinkRewardComponent = ({
  linkRewardPercentage,
  handleLinkRewardChange,
}) => {
  return (
    <>
      <Row
        className="product-register-border-box"
        wrap={false}
        style={{ marginTop: 20 }}
      >
        <span className="product-register-box-title">공유 리워드</span>
      </Row>
      <div
        className="product-register-border-box"
        wrap={false}
        style={{
          borderTop: 0,
          padding: "25px 25px 0",
          height: "fit-content",
        }}
      >
        <Form.Item
          className="product-register-form-input-wrap center-label"
          label="링크 보내는 사람 리워드 퍼센트"
          labelAlign="left"
          colon={false}
          labelCol={{ span: 2 }}
          wrapperCol={{ span: 8 }}
          maxLength={10}
        >
          <Input
            type="number"
            name="sender"
            value={linkRewardPercentage.sender}
            onChange={handleLinkRewardChange}
            placeholder="5"
            min={0}
            max={100}
            addonAfter={<span className="product-price-label">%</span>}
          />
          <Col flex="none" className="product-price-help">
            *0~100 사이로 입력해주세요.
          </Col>
        </Form.Item>

        <Divider className="product-register-form-input-divider" />
        <Form.Item
          className="product-register-form-input-wrap center-label"
          label="링크 받는 사람 리워드 퍼센트"
          labelAlign="left"
          colon={false}
          labelCol={{ span: 2 }}
          wrapperCol={{ span: 8 }}
          maxLength={10}
        >
          <Input
            type="number"
            name="receiver"
            value={linkRewardPercentage.receiver}
            onChange={handleLinkRewardChange}
            placeholder="5"
            min={0}
            max={100}
            addonAfter={<span className="product-price-label">%</span>}
          />
          <Col flex="none" className="product-price-help">
            *0~100 사이로 입력해주세요.
          </Col>
        </Form.Item>
      </div>
    </>
  );
};

export default CooperateLinkRewardComponent;
